import { ReactElement } from 'react'
import { Translate } from 'common'
import ResponsiveMenu from '../../../../ui-components/util/responsiveMenu'
import { navTextStyle } from './CommonStyles'
import { ExpandLess, ExpandMore } from '@mui/icons-material'

const Navbar = (): ReactElement => {
  const collapsedHeader = (
    <div style={{ ...navTextStyle, textTransform: 'capitalize' }}>
      {Translate('more')}
    </div>
  )

  const icon = (isOpen) =>
    isOpen === true ? (
      <ExpandLess style={navTextStyle} />
    ) : (
      <ExpandMore style={navTextStyle} />
    )

  return (
    <ResponsiveMenu
      key={new Date().getTime()}
      gap={32}
      collapsedHeader={collapsedHeader}
      statusIcon={icon}
    />
  )
}

export default Navbar
